import AuthStore from '../Store/AuthStore'

const CheckStatus = (status: number, check?: boolean) => {
  if (status === 401) {
    AuthStore.logout()
  }
  if (status === 403) {
    !check && AuthStore.forbiddenSet(true)
  }
}

export default CheckStatus
